import { lazy } from 'react'

export default {
    path: '/argomenti',
    title: 'Argomenti',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:argomentoId',
            title: 'Argomento: {{params.argomentoId}}',
            drawer: false,
            component: lazy(() => import('./detail'))
        }
    ]
}